import React from 'react';
import { Link } from 'react-router-dom';

/** Hub link target from secondary tasklist pages (matches `TasklistJsonPage`). */
export const TASKLIST_HUB_PATH = '/learning-center';
export const TASKLIST_HUB_TITLE = 'Learning Center';

/** Figma flourish — same path as prototype `Wings` (viewBox 343×200). */
const HERO_WINGS_PATH =
  'M342.912 3.52832C323.491 48.4798 321.86 98.2704 336.436 143.347C338.323 149.157 340.484 154.893 342.912 160.531V200H0C51.9107 166.262 113.945 149.825 177.305 151.772C203.905 152.607 230.681 156.663 257.062 164.01C279.728 170.375 302.065 179.154 323.689 190.436C324.223 190.699 324.693 190.996 325.2 191.24C324.78 190.818 324.349 190.468 323.956 190.064C306.323 173.174 290.897 154.777 277.663 135.343C262.288 112.682 249.879 88.5769 240.658 63.6699C232.943 42.8863 227.413 21.5389 224.141 0H342.912V3.52832Z';

/** Figma home glyph (node 18152:10276) — filled, primary on light heroes. */
const HOME_FILLED_PATH =
  'M8.66648 8.23299C8.66648 8.03547 8.66566 7.92721 8.65932 7.84953C8.65907 7.84653 8.65826 7.84375 8.65802 7.84106C8.65554 7.84084 8.65294 7.84063 8.6502 7.84041C8.57251 7.83406 8.46426 7.83325 8.26674 7.83325H6.39955C6.20203 7.83325 6.09378 7.83406 6.01609 7.84041C6.01312 7.84065 6.01029 7.84082 6.00762 7.84106C6.00738 7.84373 6.00722 7.84655 6.00697 7.84953C6.00063 7.92721 5.99981 8.03547 5.99981 8.23299V12.4999H8.66648V8.23299ZM13.3331 11.0331C13.3331 11.3955 13.3339 11.7077 13.313 11.9635C13.2941 12.194 13.2555 12.4237 13.16 12.6464L13.115 12.7415C12.9472 13.0707 12.692 13.3462 12.3787 13.5383L12.2413 13.6152C11.9891 13.7437 11.7269 13.7915 11.4634 13.8131C11.2076 13.834 10.8954 13.8332 10.533 13.8332H4.13328C3.77091 13.8332 3.45872 13.834 3.20294 13.8131C2.97235 13.7942 2.74273 13.7556 2.51999 13.6601L2.42494 13.6152C2.09568 13.4473 1.82019 13.1921 1.62807 12.8788L1.55124 12.7415C1.42274 12.4893 1.37487 12.227 1.35333 11.9635C1.33243 11.7077 1.33315 11.3955 1.33315 11.0331V5.8326L1.06622 6.03312C0.771672 6.25394 0.354163 6.19417 0.133276 5.89966C-0.0875461 5.60511 -0.0277781 5.1876 0.266739 4.96671L6.43992 0.336504C6.59626 0.221514 6.782 0.0993303 6.99395 0.0435353L7.07794 0.024655C7.24649 -0.00821866 7.4198 -0.00821804 7.58835 0.024655L7.67234 0.0435353L7.7765 0.0767384C8.0134 0.165136 8.21362 0.327088 8.37286 0.44653L14.3996 4.96671L14.4523 5.01033C14.7007 5.23932 14.74 5.62354 14.533 5.89966C14.326 6.17571 13.9461 6.2457 13.6567 6.07153L13.6001 6.03312L13.3331 5.8326V11.0331ZM9.99981 12.4999H10.533C10.9174 12.4999 11.1657 12.4991 11.3546 12.4836C11.5357 12.4688 11.6029 12.4438 11.6359 12.427L11.7251 12.3723C11.8097 12.3108 11.8789 12.23 11.9269 12.136L11.9412 12.1034C11.956 12.0621 11.9731 11.9904 11.9842 11.8547C11.9996 11.6658 11.9998 11.4175 11.9998 11.0331V4.8326L8.21335 1.99341C7.83378 1.70872 7.67764 1.59978 7.58315 1.55265L7.50307 1.52205C7.41968 1.5001 7.33285 1.49417 7.24786 1.50512L7.16322 1.52205C7.09174 1.54092 7.01264 1.58292 6.76413 1.76294L6.45294 1.99341L2.66648 4.8326V11.0331C2.66648 11.4175 2.66732 11.6658 2.68275 11.8547C2.69755 12.0358 2.7226 12.103 2.7394 12.136L2.79408 12.2252C2.85558 12.3098 2.93637 12.3791 3.03041 12.427L3.06296 12.4413C3.10426 12.4562 3.17604 12.4726 3.31166 12.4836C3.50055 12.4991 3.74891 12.4999 4.13328 12.4999H4.66648V8.23299C4.66648 8.0574 4.66574 7.88534 4.67755 7.7408C4.69001 7.58846 4.71952 7.40862 4.81166 7.22778L4.86309 7.13598C4.99119 6.92715 5.17485 6.75695 5.39434 6.6451L5.52976 6.58716C5.66365 6.53949 5.79318 6.52033 5.90736 6.51098C6.0519 6.49917 6.22396 6.49992 6.39955 6.49992H8.26674C8.44233 6.49992 8.61438 6.49917 8.75893 6.51098C8.91126 6.52345 9.09111 6.55295 9.27195 6.6451L9.36374 6.69653C9.54276 6.80633 9.69339 6.95697 9.8032 7.13598L9.85463 7.22778L9.91257 7.3632C9.96024 7.49709 9.9794 7.62662 9.98874 7.7408C10.0006 7.88534 9.99981 8.0574 9.99981 8.23299V12.4999Z';

const BREADCRUMB_SLASH_PATH = 'M5.792 0.575999L1.536 12H0.16L4.416 0.575999H5.792Z';

export type TasklistJsonPageHeaderVariant = 'task' | 'tasklist';

/** Matches prototype `DocumentHero` visual modes (Setup & Access — Figma 18152:10022). */
export type DocumentHeroVisual = 'default' | 'actionItem' | 'topLevel';

export function resolveDocumentHeroVisual(
  variant: TasklistJsonPageHeaderVariant,
  learningCenterHubLanding?: boolean
): DocumentHeroVisual {
  if (variant === 'tasklist' && learningCenterHubLanding) return 'topLevel';
  if (variant === 'task') return 'actionItem';
  return 'default';
}

export interface TasklistJsonPageHeaderProps {
  title: string;
  description: string;
  skeleton?: boolean;
  variant: TasklistJsonPageHeaderVariant;
  /**
   * With `variant="tasklist"`: breadcrumb Home → title only (no category segment) and **topLevel** hero
   * (`primary-dark`, inverted text, secondary-light wings). Omit on JSON subpages for **default** LC document hero.
   */
  learningCenterHubLanding?: boolean;
  /** Middle breadcrumb label when `visual === 'default'`; defaults to {@link TASKLIST_HUB_TITLE}. */
  categoryLabel?: string;
}

function HeroWings({ fill }: { fill: string }) {
  return (
    <svg
      className="tasklist-json-page-header__wings"
      aria-hidden="true"
      viewBox="0 0 343 200"
      preserveAspectRatio="xMaxYMid meet"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      focusable="false"
    >
      <path d={HERO_WINGS_PATH} fill={fill} />
    </svg>
  );
}

function BreadcrumbSlash({ inverted }: { inverted: boolean }) {
  return (
    <span className="tasklist-json-page-header__slash" aria-hidden="true">
      <svg className="tasklist-json-page-header__slash-svg" viewBox="0 0 6 12" fill="none" aria-hidden="true">
        <path
          d={BREADCRUMB_SLASH_PATH}
          fill={inverted ? '#FFFFFF' : '#062812'}
          fillOpacity={inverted ? 0.7 : 0.6}
        />
      </svg>
    </span>
  );
}

function HomeGlyph({ inverted }: { inverted: boolean }) {
  return (
    <svg
      className="tasklist-json-page-header__home-glyph"
      aria-hidden="true"
      viewBox="0 0 14.6664 13.8333"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d={HOME_FILLED_PATH}
        fill={inverted ? '#FFFFFF' : 'var(--primary, #0029b9)'}
      />
    </svg>
  );
}

/**
 * Document-style hero for JSON tasklist flows. Visual modes follow prototype `DocumentHero`:
 * `default` (LC item), `actionItem` (in-flow task), `topLevel` (hub landings).
 */
export default function TasklistJsonPageHeader({
  title,
  description,
  skeleton,
  variant,
  learningCenterHubLanding,
  categoryLabel = TASKLIST_HUB_TITLE,
}: TasklistJsonPageHeaderProps) {
  const visual = resolveDocumentHeroVisual(variant, learningCenterHubLanding);
  const isTopLevel = visual === 'topLevel';
  const isActionItem = visual === 'actionItem';
  const showWings = !isActionItem;
  const wingsFill = isTopLevel ? 'var(--secondary-light, #fcf3be)' : 'var(--secondary, #ffcc00)';
  const showCategory = visual === 'default';

  const visualModifier =
    visual === 'actionItem' ? 'action-item' : visual === 'topLevel' ? 'top-level' : 'default';

  const headerClass = [
    'tasklist-json-page-header',
    skeleton ? 'tasklist-json-page-header--skeleton' : '',
    `tasklist-json-page-header--variant-${visualModifier}`,
  ]
    .filter(Boolean)
    .join(' ');

  const breadcrumbNav = skeleton ? (
    <nav className="tasklist-json-page-header__breadcrumb" aria-hidden>
      <span className="tasklist-json-page-header__home tasklist-json-page-header__home--skeleton">
        <span className="placeholder placeholder-glow rounded" style={{ width: 14, height: 13, display: 'block' }} />
      </span>
      <span className="tasklist-json-page-header__slash tasklist-json-page-header__slash--skeleton" aria-hidden="true">
        /
      </span>
      {showCategory ? (
        <>
          <span
            className="placeholder placeholder-glow rounded"
            style={{ width: 120, height: 12, flexShrink: 0 }}
          />
          <span className="tasklist-json-page-header__slash tasklist-json-page-header__slash--skeleton" aria-hidden="true">
            /
          </span>
        </>
      ) : null}
      <span
        className="placeholder placeholder-glow rounded"
        style={{ height: 12, width: '100%', maxWidth: 280, minWidth: 80 }}
      />
    </nav>
  ) : (
    <nav className="tasklist-json-page-header__breadcrumb" aria-label="Breadcrumb">
      <Link to="/overview" className="tasklist-json-page-header__home" aria-label="Home">
        <HomeGlyph inverted={isTopLevel} />
        <span className="visually-hidden">Home</span>
      </Link>
      <BreadcrumbSlash inverted={isTopLevel} />
      {showCategory ? (
        <>
          <Link to={TASKLIST_HUB_PATH} className="tasklist-json-page-header__crumb-link">
            {categoryLabel}
          </Link>
          <BreadcrumbSlash inverted={isTopLevel} />
        </>
      ) : null}
      <span className="tasklist-json-page-header__crumb-current" aria-current="page">
        {title}
      </span>
    </nav>
  );

  const body = (
    <>
      {breadcrumbNav}
      {skeleton ? (
        <>
          <div className="placeholder placeholder-glow rounded" style={{ height: 40, maxWidth: '90%' }} />
          <div className="placeholder placeholder-glow rounded" style={{ height: 16, maxWidth: '100%' }} />
          <div className="placeholder placeholder-glow rounded" style={{ height: 16, maxWidth: '75%' }} />
        </>
      ) : (
        <>
          <h1 className="tasklist-json-page-header__title">{title}</h1>
          {description ? <p className="tasklist-json-page-header__desc">{description}</p> : null}
        </>
      )}
    </>
  );

  return (
    <div className="tasklist-json-page-header-wrap">
      <header className={headerClass} {...(skeleton ? { 'aria-hidden': true } : {})}>
        {showWings ? <HeroWings fill={wingsFill} /> : null}
        <div className="tasklist-json-page-header__inner">{body}</div>
      </header>
    </div>
  );
}
